export default class StoneChain {
  constructor() {
    if(new.target === StoneChain)
      throw new TypeError('StoneChain is abstract');
  }

  *iterate() {}
}

export class SimpleStoneChain extends StoneChain {
  constructor(moves) {
    super();
    this.moves = moves;
  }

  // The stones on the board after the first count records, latest first; the stones the '.set'
  // record laid out (setStones) come last.
  *iterateUntil(count) {
    let i = 0;
    for(let j = count - 1; j >= 0; j--) {
      const m = this.moves[j];
      if(!m.move.startsWith('.') && (!m.isKilledBy || m.isKilledBy >= count))
        yield [i++, m];
      for(const s of m.setStones || []) {
        if(!s.isKilledBy || s.isKilledBy >= count)
          yield [i++, s];
      }
    }
  }

  *iterate() {
    yield* this.iterateUntil(this.moves.length);
  }
}
